import { useExperiments } from '@wix/fe-essentials-standalone';

import { EXPERIMENTS } from '../constants';

const useIsArticlePageRedesignUnifiedUXEnabled = () => {
  const { experiments } = useExperiments({ readOnly: true });
  return experiments.enabled(EXPERIMENTS.SPECS.ARTICLE_PAGE_REDESIGN_UNIFIED_UX);
};

export default useIsArticlePageRedesignUnifiedUXEnabled;
